import axios from 'axios'
import endpoints from '../configuration/endpoints'
import formatImages from '../utils/formatImages'
export const REQUEST_SHIPS = 'REQUEST_SHIPS'
export const RECEIVE_SHIP_LIST = 'RECEIVE_SHIP_LIST'
export const SHIP_LIST_ERROR = 'SHIP_LIST_ERROR'
export const SET_SHIP_DETAILS = 'SET_SHIP_DETAILS'
const requestShips = () => ({
  type: REQUEST_SHIPS
})

const receiveShipList = () => ({
  type: RECEIVE_SHIP_LIST
})

const receiveShipError = () => ({
  type: SHIP_LIST_ERROR
})

const setShipDetails = shipDetails => ({
  type: SET_SHIP_DETAILS,
  payload: shipDetails
})

export const requestShipList = shipCode => dispatch => {
  dispatch(requestShips())

  return axios
    .get(endpoints.ships)
    .then(res => {
      dispatch(receiveShipList(res.data))
      const shipData = getShipByCode(res.data, shipCode)

      const ship = shipData
        ? {
            ...shipData,
            image: formatImages(shipData.image, ['details-hero'])
          }
        : null
      dispatch(setShipDetails(ship))
    })
    .catch(err => {
      console.log(err)
      dispatch(receiveShipError())
    })
}

const getShipByCode = (shipList, code) =>
  shipList.find(ship => ship.ship_code === code)
